import request from '../request';

//Get survey statistics for charts
export const getSurveyStatistics = async (surveyId) => {
  try {
    const response = await request.get(`/data-entry/statistics/surveys/${surveyId}/chart-statistics`);
    return response;
  } catch (error) {
    return { data: null, error: error.response?.data || error };
  }
};
